import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./LongTermMedicationIcon.module.scss";

import IconImage from "@/Patient/Assets/LongTermMedicationIcon.svg";

interface ILongTermMedicationIconProps {
    className?: string;
    dataCy?: string;
    height?: string;

    /**
     * Whether the icon should be visible.
     * This allows occupying the same space even when the icon shouldn't appear.
     */
    visible?: boolean;
}

function LongTermMedicationIcon(props: ILongTermMedicationIconProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <i
            className={`${styles.container} ${props.visible === false ? styles.hidden : ""} ${props.className || ""}`}
            title={getText("LongTermMedicationLabel")}
            data-cy={props.dataCy}
        >
            <IconImage height={props.height ?? "14px"} />
        </i>
    );
}

export { LongTermMedicationIcon };
